/* eslint-disable */
import r1 from './r1.js'
import a2 from './f.js'

var s = function (e) {
  function i(e, t, n) {
    return function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, e, t, n))
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(i, a2.default),
    r1(i, [{
      key: "parallax",
      value: function (e) {
        this.position.x = (this.oPosition.x + this.options.amplitude * e.x / -17).toFixed(2),
          this.position.y = (this.oPosition.y + this.options.amplitude * e.y / -27).toFixed(2)
      }
    }]),
    i
}();
var t = { default: s }

export default t
